import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Redirect } from 'react-router'

import { store } from '../../lib/utils'
import MembersPage from './MembersPage'
import Spinner from './Spinner'
import { oauthInProgressGetTokens, haveTokensCheckSubscription, noAuthSendToGumroad } from '../../lib/gumroad'


class Members extends Component {
  componentDidMount() {
    /* Already logged in, just navigated here. */
    if (store.vimeoIds) return
    const { location } = this.props
    const { accessToken, refreshToken } = store.auth
    console.log(location.query)
    if (location.query && location.query.code) {
      const code = location.query.code
      history.replaceState(null, null, location.pathname) // wipe code from URL
      oauthInProgressGetTokens(code)
    } else if (accessToken && refreshToken) {
      haveTokensCheckSubscription(accessToken, refreshToken)
    } else {
      /* We have nothing. Send the user to Gumroad */
      noAuthSendToGumroad()
    }
  }

  render() {
    const { vimeoIds, loginFailed } = store
    return loginFailed
      ? <Redirect to="/"/>
      : vimeoIds
        ? <MembersPage/>
        : <Spinner/>
  }
}

export default observer(Members)



/** WEBPACK FOOTER **
 ** ./src/components/Members/Members.js
 **/